import * as Yup from "yup";
/* eslint-disable no-useless-escape */
const phoneNumberValidationSchema = (t, countryCode) => {
  return Yup.object().shape({
    phone_number: Yup.string()
      .required(t("auth.phoneNumber.validMessage"))
      .matches(
        countryCode === "TR" ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ : /^\d{13}$/,
        t("auth.phoneNumber.validMessage")
      ),
  });
};
export default phoneNumberValidationSchema;
